var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Input from "../../InputComponent/Input";
export function assertSelectInputCell(input) {
    return (input === null || input === void 0 ? void 0 : input.type) === "select";
}
export function SelectInputCell(_a) {
    var { columnKey, onSelectChange, record, popupRenderIncludingChangeCallback } = _a, props = __rest(_a, ["columnKey", "onSelectChange", "record", "popupRenderIncludingChangeCallback"]);
    const changeValueOfSelectFromPopup = (valueToSetTo) => {
        onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange(columnKey, Object.assign(Object.assign({}, record), { [columnKey]: valueToSetTo }), {
            label: valueToSetTo,
            value: valueToSetTo
        });
    };
    return (_jsx(Input.Select, Object.assign({ "data-key": columnKey, value: record[columnKey], onChange: (value, option) => {
            onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange(columnKey, record, option);
        }, popupRender: typeof popupRenderIncludingChangeCallback === "function"
            ? popupRenderIncludingChangeCallback(changeValueOfSelectFromPopup)
            : undefined }, props)));
}
